export default {
  GET_LIST_TYPE1: '/nzjxcApi/SysRole/GetRoleList?roleType=1',
  GET_LIST_TYPE2: '/nzjxcApi/SysRole/GetRoleList?roleType=2',
  GET_LIST_TYPE3: '/nzjxcApi/SysRole/GetRoleList',
  GET_ROLE_BY_ID: '/nzjxcApi/SysRole/GetRoleByID',
  GET_MENU_BY_ID: '/nzjxcApi/SysRole/GetMenuByID',
  SAVE: '/nzjxcApi/SysRole/Save',
  //获取运营商角色
  GET_LIST_ROLE: '/nzjxcApi/DropDownData/GetList?function=Role',
  //获取经营主体角色
  GET_LIST_STORE_ROLE: '/nzjxcApi/DropDownData/GetList?function=storeRole',
  //获取政府角色
  GET_LIST_ORG_ROLE: '/nzjxcApi/DropDownData/GetList?function=orgRole'
}



// WEBPACK FOOTER //
// ./src/data/apiUrl/modules/role/index.js